/** @enum {string} — segment status values returned by the backend resultJson */
const SegmentStatus = {
  PENDING: 'Pending',
  CLASSIFYING: 'Classifying',
  CLASSIFIED: 'Classified',
  UNRECOGNIZED: 'Unrecognized',
  FAILED: 'Failed',
};

/** Human-readable labels for each segment status */
export const SEGMENT_STATUS_LABEL = {
  [SegmentStatus.PENDING]: 'Pending',
  [SegmentStatus.CLASSIFYING]: 'Classifying…',
  [SegmentStatus.CLASSIFIED]: 'Classified',
  [SegmentStatus.UNRECOGNIZED]: 'Unrecognized',
  [SegmentStatus.FAILED]: 'Failed',
};
